<script setup lang="ts">

//vue
import { onMounted, reactive, } from "vue";

//servicos
import * as service from "@/services/BoletosService";
import { f2dec, fdataHora, fdata } from "@/utils/funcoes";

//componentes
import TextBox from "@/components/TextBox/Index.vue";
import Paginador from "@/components/Paginador/Index.vue"
import Loading from "@/components/Loading/index.vue"
import BreadCrumb from "@/components/Common/BreadCrumb.vue";

import ReportView from "@/components/ReportView/Index.vue";
import CabecalhoRelatorio from "@/components/CabecalhoRelatorio/index.vue";
import { AxiosResponse } from "axios";

//janelas

interface IGrupo {
    ocorrenciaId: string;
    descricao: string;
    itens: service.BoletoRemessaItem[];
}

var controle = reactive({
    remessas: [] as service.BoletoRemessa[],
    totalRemessas: 0 as number,

    remessaId: 0 as number,
    remessa: {} as service.BoletoRemessa,
    itens: [] as service.BoletoRemessaItem[],
    itemId: 0 as number,
    totalItens: 0 as number,

    grupos: [] as IGrupo[],
    impressao: false,

    pesquisando: false,
    loading: false,
    status: "",
    erro: "",

});

var filtros = reactive<service.RemessaFiltros>({
    paginaAtual: 1,
    tamanhoPagina: 20
})

onMounted(() => {
    pesquisar();
})

const pesquisar = async () => {

    controle.erro = "";
    controle.pesquisando = true;
    controle.status = "Pesquisando...";
    //controle.itens = [] as service.BoletoRemessa[];

    service.obterRemessas(filtros)
        .then((r) => {
            controle.pesquisando = false;
            controle.status = "";
            controle.remessas = r.dados;
            controle.totalRemessas = r.totalRegistros;
        })
        .catch((erro: string) => {
            controle.pesquisando = false;
            controle.erro = erro;
            controle.status = "Erro: " + erro + "<br> Tente novamente mais tarde";
        });
};

function obterItens(remessa: service.BoletoRemessa) {
    controle.remessaId = remessa.remessaId;

    controle.loading = true;
    controle.status = "Obtendo detalhes da remessa...";

    controle.remessa = remessa;

    service.obterRemessa({ remessaId: remessa.remessaId })
        .then((r) => {
            controle.remessa = r;
            controle.itens = r.itens ?? [];
            controle.totalItens = controle.itens.length;
            controle.loading = false;
            controle.status = "";
        })
        .catch((erro: string) => {
            controle.loading = false;
            controle.status = "";
        });
}

function prepararImpressao(remessa: service.BoletoRemessa) {
    if (controle.remessaId != remessa.remessaId) {
        controle.remessaId = remessa.remessaId;
        obterItens(remessa);
    }

    //agrupar por ocorrenciaId no objeto IGrupo 
    controle.grupos = [];
    controle.itens.forEach(item => {
        var grupo = controle.grupos.find(g => g.ocorrenciaId === item.ocorrenciaId);
        if (!grupo) {
            grupo = {
                ocorrenciaId: item.ocorrenciaId,
                descricao: item.ocorrencia.descricao,
                itens: []
            };
            controle.grupos.push(grupo);
        }
        grupo.itens.push(item);
    });

    controle.impressao = true;
}



function baixar(item: service.BoletoRemessa) {
    controle.loading = true;
    controle.status = "Baixando arquivo de remessa...";
    console.log("Baixando remessa", item);

    service.baixarRemessa(item.remessaId)
        .then((r: AxiosResponse) => {
            controle.loading = false;
            controle.status = "";


            // Cria um URL para o blob
            const urlBlob = window.URL.createObjectURL(new Blob([r.data]));

            // Cria um link temporário
            const link = document.createElement('a');
            link.href = urlBlob;
            link.setAttribute('download', item.arquivo); // Define o nome do arquivo
            document.body.appendChild(link);
            link.click(); // Simula o clique no link
            document.body.removeChild(link); // Remove o link
            window.URL.revokeObjectURL(urlBlob);
        })
        .catch((erro: string) => {
            controle.loading = false;
            controle.status = "";
            controle.erro = erro;
        });
}

</script>

<template>


    <Loading :isLoading="controle.loading" :mensagem="controle.status" />

    <BreadCrumb PageTitle="Remessas" :items="[{label: 'Inicio', to: '/'}, {label: 'Boletos', to: '/boletos'}, {label: 'Remessas', to: '/boletos/remessas'}]" />

    <div class="card">
        <div class="card-body">

            <div class="row" v-if="controle.impressao == false">

                <div class="col-md-5">
                    <div class="row mb-2">
                        <div class="col-md-5 pe-0">
                            <TextBox label="Convênio" v-model="filtros.paramBoletoId"
                                class="form-control form-control-sm" />
                        </div>
                        <div class="col-md-3 pe-0">
                            <input label="Data Inicial" v-model="filtros.dataInicial" type="date"
                                class="form-control form-control-sm" />
                        </div>
                        <div class="col-md-3 pe-0">
                            <input label="Data Final" v-model="filtros.dataFinal" type="date"
                                class="form-control form-control-sm" />
                        </div>
                        <div class="col-md-1 pe-0">
                            <a class="btn btn-primary btn-sm" @click="pesquisar()">
                                <i class="fa fa-search"></i>
                            </a>
                        </div>
                    </div>

                    <div class="col-md-12 div-table-boletos box-table">
                        <table class="table table-striped table-hover table-sm table-bordered mb-0">
                            <thead class="th-fixed">
                                <tr>
                                    <th class="text-center"></th>
                                    <th class="text-end">Id</th>
                                    <th class="text-center">Data</th>
                                    <th class="text-start">Convênio</th>
                                    <th class="text-end">Remessa</th>
                                    <!-- <th class="text-start">Arquivo</th> -->
                                    <th class="text-end">Itens</th>
                                    <th class="text-end">Total R$</th>
                                    
                                </tr>
                            </thead>
                            <tbody>

                                <tr class="col-md-12 text-center table-danger" v-show="controle.erro != ''">
                                    <td colspan="15" class="text-center">
                                        <div class="d-inline">
                                            <i class="fa fa-exclamation"></i>
                                            {{ controle.erro }}
                                        </div>
                                        <a class="btn btn-primary btn-sm" @click="pesquisar()">Repetir</a>
                                    </td>
                                </tr>

                                <tr v-for="(item, idx) in controle.remessas" :key="idx"
                                    :class="controle.remessaId == item.remessaId ? 'table-active' : ''"
                                    @click="obterItens(item)">
<td class="text-center" data-label="Opções">
                                        <a class="" href="javascript:void(0)" @click="prepararImpressao(item);"
                                            title="Exibir detalhes da remessa">
                                            <i class="fa fa-print"></i>
                                        </a>

                                        <a class="ms-2" href="javascript:void(0)" @click="baixar(item);"
                                            title="Baixar remessa">
                                            <i class="fa fa-download"></i>
                                        </a>
                                    </td>
                                    <td class="text-end">{{ item.remessaId }}</td>
                                    <td class="text-center">{{ fdataHora(item.dataRemessa) }}</td>
                                    <td class="text-start">{{ item.paramBoleto?.cedenteCodigo }}</td>
                                    <td class="text-end">{{ item.numeroRemessa }}</td>
                                    <!-- <td class="text-start">{{ item.nomeArquivo }}</td> -->
                                    <td class="text-end">{{ item.qtdeItens }}</td>
                                    <td class="text-end">{{ f2dec(item.total) }}</td>
                                    
                                </tr>
                            </tbody>
                        </table>
                    </div>

                   

                </div>

                <div class="col-md-7">

                    <div class="row mb-2">
                        <div class="col-md-5 pe-0">
                            <TextBox placeholder="Pesquisar nome, cliente" v-model="filtros.paramBoletoId"
                                class="form-control form-control-sm" />
                        </div>
                        <div class="col-md-3 pe-0">
                            <input label="Data Inicial" v-model="filtros.dataInicial" type="date"
                                class="form-control form-control-sm" />
                        </div>
                        <div class="col-md-3 pe-0">
                            <input label="Data Final" v-model="filtros.dataFinal" type="date"
                                class="form-control form-control-sm" />
                        </div>
                        <div class="col-md-1 pe-0">
                            <a class="btn btn-primary btn-sm" @click="pesquisar()">
                                <i class="fa fa-search"></i>
                            </a>
                        </div>
                    </div>

                    <div class="col-md-12 div-table-boletos box-table">
                        <table class="table table-striped table-hover table-sm table-bordered">
                            <thead class="th-fixed">
                                <tr>
                                    <th class="text-end">Id</th>
                                    <th class="text-center">Ocorrência</th>
                                    <th class="text-start">Cliente</th>
                                    <th class="text-start">Nome</th>
                                    <th class="text-start">Vencimento</th>
                                    <th class="text-end">Valor R$</th>
                                    <th class="text-center"></th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr class="col-md-12 text-center table-danger" v-show="controle.erro != ''">
                                    <td colspan="15" class="text-center">
                                        <div class="d-inline">
                                            <i class="fa fa-exclamation"></i>
                                            {{ controle.erro }}
                                        </div>
                                        <a class="btn btn-primary btn-sm" @click="pesquisar()">Repetir</a>
                                    </td>
                                </tr>

                                <tr v-for="(item, idx) in controle.itens" :key="idx"
                                    :class="controle.itemId == item.id ? 'table-active' : ''"
                                    @click="controle.itemId = item.id;">

                                    <td class="text-end">{{ item.id }}</td>
                                    <td class="text-start">{{ item.ocorrenciaId }} {{ item.ocorrencia?.descricao }}</td>
                                    <td class="text-start">{{ item.boleto?.clienteId }}</td>
                                    <td class="text-start">{{ item.boleto?.sacadoNome }}</td>
                                    <td class="text-start">{{ fdata(item.boleto?.dataVencimento) }}</td>
                                    <td class="text-end">{{ f2dec(item.boleto?.valorDocumento) }}</td>
                                    <td class="text-center" data-label="Opções">
                                        <a class="" href="javascript:void(0)" title="Exibir detalhes do boleto">
                                            <i class="fa fa-search"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>

            <div class="row" v-if="controle.impressao == true">
                <div class="col-md-12  d-print-none">
                    <a class="btn btn-primary btn-sm mb-2" @click="controle.impressao = false">
                        <i class="fa fa-close"></i> Fechar impressão
                    </a>
                </div>
                <div class="col-md-12">
                    <ReportView :titulo="'Detalhes da remessa'">

                        <!-- <CabecalhoRelatorio 
                        :Titulo="`Detalhes da remessa : ${controle.remessaId} - Convênio ${controle.remessa.paramBoleto?.cedenteCodigo}`" 
                        :Filtros="`Data: ${fdata(controle.remessa.dataRemessa)}`" /> -->

                        <hr>
                        <div class="row">
                            <div class="col-md-12 col-sm-12 overflow-auto">
                                <template v-for="(grupo, idx1) in controle.grupos" :key="idx1">
                                    <h5>{{ grupo.ocorrenciaId }} - {{ grupo.descricao }}</h5>
                                    <table
                                        class="tabela table-print table-sm table-bordered tabela-completa table-striped w-100"
                                        id="tabela-linear-sintetico">
                                        <thead>
                                            <tr class="table-relatorio">
                                                <th class="text-end">Pedido</th>
                                                <th class="text-start">Nosso número</th>
                                                <th class="text-center">Emissão</th>
                                                <th class="text-center">Vencimento</th>
                                                <th class="text-end">Valor R$</th>
                                                <th class="text-end">Desc R$</th>
                                                <th class="text-end">Total R$</th>
                                                <th class="text-end">Cliente</th>
                                                <th class="text-start">Razão Social</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, idx) in grupo.itens" :key="idx">
                                                <td class="text-end">{{ item.boleto?.pedidoId }}</td>
                                                <td class="text-start">{{ item.boleto?.nossoNumero }}</td>
                                                <td class="text-center">{{ fdata(item.boleto?.dataDocumento) }}</td>
                                                <td class="text-center">{{ fdata(item.boleto?.dataVencimento) }}</td>
                                                <td class="text-end">{{ f2dec(item.boleto?.valorDocumento) }}</td>
                                                <td class="text-end">{{ f2dec(item.boleto?.vlrDesconto) }}</td>
                                                <td class="text-end">{{ f2dec(item.boleto?.valorDocumento -
                                                    item.boleto?.vlrDesconto) }}</td>
                                                <td class="text-end">{{ item.boleto?.clienteId }}</td>
                                                <td class="text-start">{{ item.boleto?.sacadoNome }}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td class="text-start" colspan="4"></td>
                                                <td class="text-end fw-bold">{{f2dec(grupo.itens.reduce((acc, item) =>
                                                    acc + (item.boleto?.valorDocumento || 0), 0)) }}</td>
                                                <td class="text-end fw-bold">{{f2dec(grupo.itens.reduce((acc, item) =>
                                                    acc + (item.boleto?.vlrDesconto || 0), 0)) }}</td>
                                                <td class="text-end fw-bold">{{f2dec(grupo.itens.reduce((acc, item) =>
                                                    acc + ((item.boleto?.valorDocumento || 0) -
                                                    (item.boleto?.vlrDesconto || 0)), 0)) }}</td>
                                                <td class="text-start fw-bold" colspan="2">{{ grupo.itens.length }} Itens
                                                </td>
                                            </tr>
                                        </tfoot>

                                    </table>
                                </template>
                            </div>
                        </div>
                    </ReportView>
                </div>
            </div>

        </div>

        <div class="card-footer">
            <div class="row">
                <div class="col-md-5">
                    <div class="row mt-2" v-if="controle.impressao == false">
                        <div class="col-md-10">
                            <Paginador :paginaAtual="filtros.paginaAtual ?? 1"
                                :tamanhoPagina="filtros.tamanhoPagina ?? 10"
                                :totalRegistros="controle.totalRemessas ?? 0" @on-change="(r) => {
                                    filtros.paginaAtual = r.paginaAtual;
                                    filtros.tamanhoPagina = r.tamanhoPagina;
                                    pesquisar();
                                }" />
                        </div>
                        <div class="col-md-2">
                            {{ controle.remessas.length }} Itens
                        </div>
                    </div>
                </div>

                <div class="col-md-7">
                    <RouterLink class="btn btn-sm btn-primary me-1 float-end" to="/boletos" title="Fechar">
                        Fechar
                    </RouterLink>
                </div>
            </div>
        </div>
    </div>

    

</template>

<style scoped>
.div-table-boletos {
    max-height: calc(100vh - 220px);
    min-height: calc(100vh - 220px);
    overflow: auto;
}
</style>